import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FooterLinks from "../components/FooterLinks";
import Team from "../components/Team";
import Chat from "../components/Chat";

const TeamPage = () => {
  return (
    <>
      {/* Navbar Component*/}
      <Navbar />
      <section
        className="section bg-home home-half"
        id="home"
        data-image-src="images/bg-home.jpg"
      >
        <div className="bg-overlay"></div>
        <div className="display-table">
          <div className="display-table-cell">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 offset-lg-2 text-white text-center">
                  <h1 className="home-title">Our Team</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-pattern-effect">
          <img src="images/bg-pattern.png" alt="" />
        </div>
      </section>

      <br />
      <br />
      <br />
      <section>
        <div className="container">
          <Team />
        </div>
      </section>

      {/* Footer Component*/}
      <Footer />

      {/* FooterLinks Component*/}
      <FooterLinks />
        {/* Chat Component*/}
    <Chat />
    </>
  );
};

export default TeamPage;
